<template>
  <div class="home-container">
    <div class="nav-bar keep-px">
      <div class="nav-bar-left" @click="showSideBar">
        <img v-if="configInfo" :src="configInfo.site_logo" alt="" />
      </div>
      <div class="nav-bar-mid">
        <van-tabs :ellipsis="false" v-model="active">
          <van-tab :title="$t('defi_host_non-collateralized')"></van-tab>
        </van-tabs>
      </div>
      <div class="nav-bar-right">
        <van-popover
          v-model="showPopover"
          trigger="click"
          :actions="actions"
          @select="onSelect"
          get-container=".nav-bar-right"
          placement="bottom-end"
        >
          <template #reference>
            <img src="../../assets/language.svg" alt="" />
          </template>
        </van-popover>
      </div>
    </div>
    <div class="swipe-bar">
      <van-swipe
        height="320"
        class="my-swipe"
        :autoplay="3000"
        :show-indicators="false"
        indicator-color="white"
      >
        <van-swipe-item v-for="item in banner" :key="item.image"
          ><img :src="item.image" alt=""
        /></van-swipe-item>
      </van-swipe>
    </div>
    <van-notice-bar v-if="notifyInfo.length != 0" :text="notifyText" color="#1989fa" scrollable left-icon="volume-o" background="#ecf9ff" />
    <div class="type-bar">
      <van-tabs
        :ellipsis="false"
        @click="changeTypeActive"
        v-model="typeActive"
      >
        <van-tab :title="$t('defi_host_non-collateralized mining')"></van-tab>
        <van-tab :title="$t('mining_pool_rewards')"></van-tab>
      </van-tabs>
    </div>
    <div class="activity-box" v-if="typeActive == 1 && activityList.length > 0">
      <div class="activity-box-title">
        {{ $t("activity") }}
      </div>
      <div
        class="activity-box-content"
        v-for="item in activityList"
        :key="item.id"
      >
        <div class="activity-box-content-row">
          <div class="row-lef">
            {{ $t("standard") }}
          </div>
          <div class="row-right">
            {{ item.balance_amount }} {{ item.balance_currency.toUpperCase() }}
          </div>
        </div>
        <div class="activity-box-content-row">
          <div class="row-lef">
            {{ $t("output") }}
          </div>
          <div class="row-right">
            {{ item.award_amount }} {{ item.award_currency.toUpperCase() }}
          </div>
        </div>
        <div class="activity-box-content-row">
          <div class="row-lef">
            {{ $t("wallet_balance") }}
          </div>
          <div class="row-right">
            {{ item.balance }} {{ item.balance_currency.toUpperCase() }}
          </div>
        </div>
        <div class="activity-box-content-row">
          <div class="row-lef">
            {{ $t("required") }}
          </div>
          <div class="row-right">
            {{ item.need_deposit }} {{ item.balance_currency.toUpperCase() }}
          </div>
        </div>
        <div class="activity-box-content-row">
          <div class="row-lef">
            {{ $t("option_countdown") }}
          </div>
          <div class="row-right">
            <!-- <van-count-down
              :time="((item.end_time*1000) - new Date().getTime())"
              :format="'DD ' + $t('host_day')"
            /> -->
            {{
              item.end_time * 1000 - new Date().getTime() > 0
                ? parseInt(
                    (item.end_time * 1000 - new Date().getTime()) / 86400000
                  )
                : 0
            }}
            {{ $t("host_day") }}
          </div>
        </div>
        <div class="activity-box-content-btn" @click="receiveActivity(item.id)">
          {{ $t("reward") }}&nbsp;{{ item.award_amount }}
          {{ item.award_currency.toUpperCase() }}
        </div>
      </div>
    </div>
    <div
      class="account-box"
      v-if="typeActive == 1 && +userInfo.authorized_usdt > 0"
    >
      <div class="account-box-title">
        {{ $t("my_account") }}
      </div>
      <div class="account-box-content">
        <div class="account-box-content-row">
          <div class="row-lef">
            {{ $t("mining_status") }}
          </div>
          <div class="row-right">{{ $t("host_processing") }}</div>
        </div>
        <div class="account-box-content-row">
          <div class="row-lef">
            {{ $t("host_income") }}
          </div>
          <div class="row-right">{{ incomeStat.eth }} ETH</div>
        </div>
        <div class="account-box-content-row">
          <div class="row-lef">
            {{ $t("wallet_balance") }}
          </div>
          <div class="row-right">{{ incomeStat.usdt }} USDT</div>
        </div>
      </div>
    </div>
    <div
      class="hosting-box"
      v-if="typeActive == 0 && +userInfo.authorized_usdt > 0"
    >
      <div class="hosting-box-title">
        <div class="logo-box">
          <img src="../../assets/eth-logo.svg" alt="" />
        </div>
        <div class="title">ETH <span>Ethereum</span></div>
      </div>
      <div class="hosting-box-content">
        <div class="hosting-box-content-top">
          <div class="top-title">
            {{ $t("host_funds in custody") }}
          </div>
          <div class="top-bot">{{ notStakingMiningStat.usdt }} USDT</div>
        </div>
        <div class="hosting-box-content-bot">
          <div class="bot-col">
            <div class="bot-col-top">
              {{ $t("host_single benefit") }}
            </div>
            <div class="bot-col-mid">{{ notStakingMiningStat.income }}</div>
            <div class="bot-col-bot">ETH</div>
          </div>
          <div class="bot-col">
            <div class="bot-col-top">
              {{ $t("host_single day income") }}
            </div>
            <div class="bot-col-mid">{{ notStakingMiningStat.income_day }}</div>
            <div class="bot-col-bot">ETH</div>
          </div>
          <div class="bot-col">
            <div class="bot-col-top">
              {{ $t("host_total revenue") }}
            </div>
            <div class="bot-col-mid">{{ notStakingMiningStat.sum }}</div>
            <div class="bot-col-bot">ETH</div>
          </div>
        </div>
      </div>
      <div class="hosting-box-btn" @click="goIncome">
        {{ $t("host_earnings Details") }}
      </div>
    </div>
    <div class="defi-box" v-if="+userInfo.authorized_usdt == 0">
      <div class="defi-box-title">
        <div class="logo-box">
          <img src="../../assets/eth-logo.svg" alt="" />
        </div>
        <div class="title">ETH <span>Ethereum</span></div>
      </div>
      <div class="defi-box-content">
        <div class="defi-box-content-row">
          <div class="col-row">
            <div class="col-row-top">{{ $t("total_output") }}</div>
            <div class="col-row-bot">
              {{ miningStat.total_product }}&nbsp;&nbsp;ETH
            </div>
          </div>
          <div class="col-row">
            <div class="col-row-top">{{ $t("valid_node") }}</div>
            <div class="col-row-bot">{{ miningStat.valid_node }}</div>
          </div>
        </div>
        <div class="defi-box-content-row">
          <div class="col-row">
            <div class="col-row-top">{{ $t("participant") }}</div>
            <div class="col-row-bot">{{ miningStat.players }}</div>
          </div>
          <div class="col-row">
            <div class="col-row-top">{{ $t("user_benefit") }}</div>
            <div class="col-row-bot">{{ miningStat.earn }}&nbsp;&nbsp;USDT</div>
          </div>
        </div>
        <div class="join-btn" @click="join" v-if="showJoin">{{ $t("participate_mining") }}</div>
      </div>
    </div>
    <div class="income-box" v-if="typeActive == 0 && hideIncomeBox !=='true'">
      <div class="income-box-title">
        <div class="title">{{ $t("rule_fzywk_til3_1") }}</div>
        <div class="view-intro" @click="viewIntro">
          {{ $t("view_desc") }}
          <img src="../../assets/arrow-right.svg" alt="" />
        </div>
      </div>
      <div class="income-box-table">
        <table data-v-557a7b05="" class="table">
          <thead data-v-557a7b05="" class="head">
            <tr data-v-557a7b05="">
              <th data-v-557a7b05="">{{ $t("rule_fzywk_tab1") }}</th>
              <th data-v-557a7b05="">{{ $t("rule_fzywk_tab2") }}</th>
              <th data-v-557a7b05="">{{ $t("rule_fzywk_tab3") }}</th>
              <th data-v-557a7b05="">{{ $t("rule_fzywk_tab4") }}</th>
            </tr>
          </thead>
          <tbody data-v-557a7b05="">
            <tr
              v-for="(item, index) in notStakingRateList"
              :key="item.id"
              data-v-557a7b05=""
              class="row"
            >
              <td
                v-if="index != notStakingRateList.length - 1"
                data-v-557a7b05=""
              >
                {{ showTableVip == "true" ? "VIP" : "" }}{{ index + 1 }}
              </td>
              <td
                v-if="index != notStakingRateList.length - 1"
                data-v-557a7b05=""
              >
                {{ item.money }} ~ {{ notStakingRateList[index + 1].money }}
              </td>
              <td
                v-if="index != notStakingRateList.length - 1"
                data-v-557a7b05=""
              >
                {{
                  rateMode == "percent"
                    ? (item.rate * 100).toFixed(2) + "%"
                    : item.rate
                }}
                ~
                {{
                  rateMode == "percent"
                    ? (notStakingRateList[index + 1].rate * 100).toFixed(2) +
                      "%"
                    : notStakingRateList[index + 1].rate
                }}
              </td>
              <td
                v-if="index == 0 && index != notStakingRateList.length - 1"
                data-v-557a7b05=""
                :rowspan="notStakingRateList.length"
              >
                ETH
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="user-output">
      <div class="user-output-title">
        <div class="title">{{ $t("host_user output") }}</div>
      </div>
      <div class="user-output-list">
        <div class="user-output-list-top">
          <div class="top-left">{{ $t("host_address") }}</div>
          <div class="top-right">{{ $t("host_quantity") }}</div>
        </div>
        <SoMarquee
          :data="jsonData"
          :height="100"
          :showNumber="3"
          :speed="1500"
          class="my-ui-marquee"
        >
          <template v-slot:itemCon="{ item }">
            <div>{{ item.address }}</div>
            <div>{{ item.num }}</div>
          </template>
        </SoMarquee>
      </div>
    </div>
    <div class="question-box">
      <div class="question-box-title">
        <div class="title">{{ $t("promble") }}</div>
      </div>
      <div class="question-box-content">
        <van-collapse v-model="activeName" accordion>
          <van-collapse-item :title="$t('mining.question8')" name="1" v-if="configQuestion !== 'true'">{{
            $t("mining.answer8")
          }}</van-collapse-item>
          <van-collapse-item :title="$t('mining.question9')" name="2" v-if="configQuestion !== 'true'">{{
            $t("mining.answer9")
          }}</van-collapse-item>
          <van-collapse-item :title="$t('mining.question10')" name="3" v-if="configQuestion !== 'true'">{{
            $t("mining.answer10")
          }}</van-collapse-item>
          <van-collapse-item :title="$t('mining2455.question4')" name="4" v-if="mining2455 === 'true'" style="white-space:pre-wrap">{{
            $t("mining2455.answer4")
          }}</van-collapse-item>
          <van-collapse-item :title="$t('mining2455.question5')" name="5" v-if="mining2455 === 'true'" style="white-space:pre-wrap">{{
            $t("mining2455.answer5")
          }}</van-collapse-item>

          <template v-if="configQuestion === 'true'">
            <van-collapse-item v-for="(item,index) in questionList" :key="item.id" :title="item.question" 
              :name="index + 1" style="white-space:pre-wrap">{{item.answer}}</van-collapse-item>
          </template>
        </van-collapse>
      </div>
    </div>
    <div class="gency-box">
      <div class="gency-box-title">
        <div class="title">{{ $t("coinbase_ho_tit1") }}</div>
      </div>
      <div class="gency-box-content">
        <div class="gency-img">
          <img src="../../assets/open.png" alt="" />
        </div>
        <div class="gency-img">
          <img src="../../assets/consensys.png" alt="" />
        </div>
      </div>
    </div>
    <div class="partner-box">
      <div class="partner-box-title">
        <div class="title">{{ $t("coinbase_ho_tit7") }}</div>
      </div>
      <div class="partner-box-content">
        <img v-for="item in partnerList" :key="item" :src="item" alt="" />
      </div>
    </div>
    <div
      class="contact-btn"
      v-if="serviceBtnShow == 'show'"
      @click="serviceShow = true"
    >
      <img src="../../assets/contact2.png" alt="" />
    </div>
    <HomePop
      v-if="showPop"
      :serviceUrl="serviceUrl ? serviceUrl.url : ''"
      @showService="showService"
      ref="homePop"
    />
    <IncomeIntro :notStakingRateList="notStakingRateList" ref="incomeIntro" />

    <van-popup v-model="serviceShow" style="width: 90%; border-radius: 10px">
      <div class="service-box">
        <div
          class="service-box-btn"
          v-if="serviceUrl && serviceUrl.url"
          @click="goService(serviceUrl.url)"
        >
          {{ $t("home_service") }}
        </div>
        <div
          class="service-box-btn"
          v-if="serviceUrl && serviceUrl.whatsapp"
          @click="goService(serviceUrl.whatsapp)"
        >WhatApp</div>
        <div
          class="service-box-btn"
          v-if="serviceUrl && serviceUrl.telegram"
          v-clipboard:copy="serviceUrl.telegram"
          v-clipboard:success="onCopy"
        >
          Telegram({{ serviceUrl.telegram }})
        </div>
        <div
          class="service-box-btn"
          v-clipboard:copy="serviceUrl.email"
          v-clipboard:success="onCopy"
          v-if="serviceUrl && serviceUrl.email"
        >
          Email({{ serviceUrl.email }})
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import SoMarquee from "@/components/SoMarquee";
import HomePop from "@/components/HomePop";
import IncomeIntro from "@/components/IncomeIntro";
import Web3 from "web3";
import userOutPut from "@/utils/userOutput";
import { Dialog } from "vant";
import { EventBus } from "../../eventbus.js";
import tools from "@/utils/tools";

export default {
  components: {
    SoMarquee,
    HomePop,
    IncomeIntro,
  },
  data() {
    return {
      serviceBtnShow: "show",
      serviceShow: false,
      typeActive: 0,
      banner: [],
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [],
      show: true,
      partnerList: [
        require("../../assets/partner1.png"),
        require("../../assets/partner2.png"),
        require("../../assets/partner3.png"),
        require("../../assets/partner4.png"),
        require("../../assets/partner5.png"),
        require("../../assets/partner6.png"),
        require("../../assets/partner7.png"),
        require("../../assets/partner8.png"),
        require("../../assets/partner9.png"),
      ],
      activeName: [],
      active: 0,
      jsonData: [],
      notStakingRateList: [],
      activityList: [],
      notStakingMiningStat: "",
      userInfo: "",
      incomeStat: "",
      miningStat: "",
      inviteCode: "",
      serviceUrl: undefined,
      change: false,
      showPop: false,
      configInfo: "",
      rateMode: "origin",
      showTableVip: false,
      showJoin: true,
      mining2455: '', //admin-mining2455.top 定制
      configQuestion: '',
      questionList : [],
      hideIncomeBox: '',
      notifyText: '',
      notifyInfo: []
    };
  },
  async created() {
    window.scrollTo(0, 0);
    this.configQuestion = process.env.VUE_APP_CONFIG_QUESTION;
    this.serviceBtnShow = process.env.VUE_APP_SERVICE_BTN;
    this.showTableVip = process.env.VUE_APP_TABLE_VIP;
    this.mining2455 = process.env.VUE_APP_MINING2455;
    this.hideIncomeBox = process.env.VUE_APP_HIDE_INCOME_BOX;
    this.inviteCode = this.$route.params.code;
    this.jsonData = userOutPut.data;
    await this.$onLaunched;
    this.getNotify()
    this.getLanguageList();
    this.getBanner();
    this.getMiningStat();
    if(this.configQuestion === 'true'){
      this.getConfigQuestion()
    }

    this.getNotStakingMiningRate();
    this.getService();
  },
  // beforeRouteEnter(to, from, next) {
  //   if (
  //     typeof window.ethereum == "undefined" &&
  //     typeof window.tronWeb == "undefined"
  //   ) {
  //     Dialog.alert({
  //       message: "Please use it in the wallet",
  //       confirmButtonText: "confirm",
  //     }).then(() => {
  //       // on close
  //       location.reload();
  //     });
  //   } else {
  //     next();
  //   }
  // },
  computed: {
    requestStatus() {
      return this.$store.state.requestStatus;
    },
  },
  watch: {
    requestStatus(newVal, oldVal) {
      if (newVal) {
        this.getUserInfo();
        this.getActivityList();
        this.getIncomeStat();
        this.getNotStakingMiningStat();
        let timer = setInterval(() => {
          if (localStorage.getItem("addData") != "") {
            this.userAddress = localStorage.getItem("addData");
            clearInterval(timer);
          }
        }, 100);

        this.$store.commit("changeRequestStatus", false);
      }
    },
  },
  async mounted() {
    this.rateMode = process.env.VUE_APP_PERCENT;
    this.userAddress = localStorage.getItem("addData");
    await this.$onLaunched;
    this.getConfig();
    // 初始化 Web3 实例
    // this.getConfig()
    if (localStorage.getItem("app_token")) {
      await this.getUserInfo();
      this.getActivityList();
      this.getIncomeStat();
      this.getNotStakingMiningStat();
    }
    EventBus.$on("isApply", (msg) => {
      console.log(msg);
      if (msg == 1) {
        this.typeActive = 1;
      }
    });
    setInterval(async () => {
      await this.getUserInfo();
    }, 15000);
    // this.getTextConfig()
  },
  destroyed() {
    EventBus.$off("isApply");
  },
  methods: {
    async getNotify() {
      const res = await this.$api.getNotify()
      if(res.code == 200) {
        let text = ''
        res.data.forEach((item)=> {
          text += item.content + ''
        })
        this.notifyInfo = res.data
        this.notifyText = text
      }
    },
    async getConfig() {
      const res = await this.$api.getConfig();
      if (res.code == 200) {
        this.configInfo = res.data;
      }
    },
    async getTextConfig() {
      const res = await this.$api.getTextConfig();
    },
    showService() {
      this.serviceShow = true;
    },
    goTelegram() {
      window.open("https://t.me/" + this.serviceUrl.telegram);
    },
    onCopy() {
      this.$Toast(this.$t("copySuccess"));
    },
    async changeTypeActive() {
      if (this.userInfo.authorized_usdt > 0) {
        await this.getUserInfo();
      }
    },
    goService(url) {
      window.location = url;
    },
    async getService() {
      const res = await this.$api.getService();
      if (res.code == 200) {
        this.serviceUrl = res.data;
      }
    },
    async getMiningStat() {
      const res = await this.$api.getMiningStat();
      if (res.code == 200) {
        this.miningStat = res.data;
      }
    },
    async getIncomeStat() {
      const res = await this.$api.getIncomeStat();
      if (res.code == 200) {
        this.incomeStat = res.data;
      }
    },
    goIncome() {
      this.$router.push("/income-detail");
    },
    async getActivityList() {
      const res = await this.$api.getActivityList();
      if (res.code == 200) {
        this.activityList = res.data;
      }
    },
    async receiveActivity(id) {
      const res = await this.$api.receiveActivity({ id });
      if (res.code == 200) {
        this.$Toast(this.$t("successful application"));
        this.getActivityList();
      } else {
        this.$Toast(res.message);
      }
    },

    viewIntro() {
      this.$refs.incomeIntro.show = true;
    },
    async join() {
      this.showJoin = false;
      if (await tools.join()) {
        location.reload();
      }
      this.showJoin = true;
    },
    async getLanguageList() {
      const res = await this.$api.getLanguageList();
      if (res.code == 200) {
        this.actions = res.data.map((item) => {
          return {
            id: item.id,
            text: item.title,
            key: item.key,
          };
        });
      }
    },
    showSideBar() {
      this.$refs.homePop.show = true;
    },
    onSelect(action) {
      console.log(action);
      this.$i18n.locale = action.key;
      this.setLanguage(action.key);
      this.getBanner();
      this.getNotify()
      if(this.configQuestion === 'true'){
        this.getConfigQuestion()
      }
    },
    async getBanner() {
      const res = await this.$api.getBanner({ type: 1 });
      if (res.code == 200) {
        this.banner = res.data;
      }
    },
    async getConfigQuestion(){
      const res = await this.$api.getQuestion();
      if (res.code == 200) {
        this.questionList = res.data;
      }
    },
    async login(signature, address, message, invite) {
      let data = {
        signature,
        address,
        message,
        invite,
      };
      const res = await this.$api.login(data);
      if (res.code == 200) {
        this.change = false;
        this.setToken(res.data.token);
        localStorage.setItem("signature", signature);
        localStorage.setItem("account", address);
        setTimeout(() => {
          location.reload();
        }, 300);
      }
    },
    async getUserInfo() {
      const res = await this.$api.getUserInfo();
      if (res.code == 200) {
        this.showPop = true;
        this.userInfo = res.data;
        localStorage.setItem("userInfo", JSON.stringify(res.data));
      }
    },
    async getNotStakingMiningRate() {
      const res = await this.$api.getNotStakingMiningRate();
      if (res.code == 200) {
        this.notStakingRateList = res.data;
      }
    },
    async getNotStakingMiningStat() {
      const res = await this.$api.getNotStakingMiningStat();
      if (res.code == 200) {
        this.notStakingMiningStat = res.data;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .van-tab--active {
  color: #0062f8;
  font-weight: 700;
  font-size: 16px;
}

/deep/ .van-tabs__line {
  background: #0062f8;
}

/deep/ .van-popover__action {
  width: 130px;
  padding: 0 5px;
}

/deep/ .van-popover__arrow {
  display: none;
}

.home-container {
  background: #f9fafb;
  padding-top: 65px;
  position: relative;

  .nav-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    box-sizing: border-box;
    background: #fff;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10;

    &-left {
      img {
        width: 30px;
        height: 30px;
      }
    }

    &-right {
      background: #f5f7f9;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      img {
        width: 25px;
        height: 25px;
      }
    }
  }

  .swipe-bar {
    .my-swipe {
      img {
        width: 100%;
        height: 320px;
        object-fit: cover;
      }
    }
  }

  .type-bar {
    border-bottom: 1px solid #efefef;

    /deep/ .van-tab--active {
      color: #333;
    }
  }

  .activity-box {
    padding: 15px;

    &-title {
      font-weight: bold;
      font-size: 16px;
    }

    &-content {
      width: 100%;
      box-sizing: border-box;
      background: #fff;
      border-radius: 8px;
      margin-top: 15px;
      padding: 15px;
      box-shadow: 0 1px 5px 3px rgba(0, 0, 0, 0.05);

      &-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        font-size: 14px;

        .row-right {
          font-weight: bold;
        }
      }

      &-btn {
        width: 100%;
        border-radius: 5px;
        padding: 15px 0;
        color: #fff;
        text-align: center;
        background: #9169fd;
        font-size: 14px;
      }
    }
  }

  .account-box {
    padding: 15px;

    &-title {
      font-weight: bold;
      font-size: 16px;
    }

    &-content {
      width: 100%;
      box-sizing: border-box;
      background: #fff;
      border-radius: 8px;
      margin-top: 15px;
      padding: 15px;
      box-shadow: 0 1px 5px 3px rgba(0, 0, 0, 0.05);

      &-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        font-size: 14px;

        &:last-child {
          margin-bottom: 0;
        }

        .row-right {
          font-weight: bold;
        }
      }
    }
  }

  .hosting-box {
    background: #fff;
    width: 93%;
    box-sizing: border-box;
    margin: 0 auto;
    margin-top: 15px;
    border-radius: 8px;
    box-shadow: 0 1px 5px 3px rgba(0, 0, 0, 0.05);
    padding: 15px;

    &-title {
      display: flex;
      align-items: center;

      .logo-box {
        width: 30rpx;
        height: 30rpx;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #efefef;
        margin-right: 10px;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .title {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: bold;

        span {
          background: #fdf8e5;
          padding: 3px;
          color: #4288f4;
          font-weight: 500;
          font-size: 12px;
          margin-left: 5px;
        }
      }
    }

    &-content {
      margin-top: 20px;

      &-top {
        .top-title {
          font-size: 12px;
        }

        .top-bot {
          font-size: 14px;
          margin-top: 3px;
        }
      }

      &-bot {
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-top: 15px;

        .bot-col {
          display: flex;
          flex-direction: column;
          align-items: center;

          &-top {
            font-size: 12px;
          }

          &-mid {
            font-size: 14px;
            margin-top: 3px;
          }

          &-bot {
            margin-top: 5px;
            font-size: 14px;
          }
        }
      }
    }

    &-btn {
      width: 100%;
      font-size: 14px;
      color: #fff;
      background: linear-gradient(90deg, #096cfe, #30c6ff);
      margin-top: 15px;
      text-align: center;
      padding: 12px 0;
      box-sizing: border-box;
      border-radius: 30px;
      font-weight: bold;
    }
  }

  .defi-box {
    padding: 20px;

    &-title {
      display: flex;
      align-items: center;

      .logo-box {
        width: 30rpx;
        height: 30rpx;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #efefef;
        margin-right: 10px;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .title {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: bold;

        span {
          background: #fdf8e5;
          padding: 3px;
          color: #4288f4;
          font-weight: 500;
          font-size: 12px;
        }
      }
    }

    &-content {
      &-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 15px;

        .col-row {
          flex: 1;

          &-top {
            font-size: 12px;
          }

          &-bot {
            font-size: 14px;
            margin-top: 5px;
          }
        }
      }

      .join-btn {
        width: 90%;
        background: linear-gradient(90deg, #096cfe, #30c6ff);
        font-size: 14px;
        font-weight: bold;
        color: #fff;
        text-align: center;
        padding: 13px 0;
        margin: 0 auto;
        margin-top: 15px;
        border-radius: 50px;
      }
    }
  }

  .income-box {
    padding: 0 15px;
    margin-top: 15px;

    &-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;

      .title {
        font-size: 14px;
        font-weight: bold;
        display: flex;
        align-items: center;

        &::before {
          display: block;
          content: "";
          width: 5px;
          height: 5px;
          background: #000;
          margin-right: 5px;
        }
      }

      .view-intro {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #0062f8;

        img {
          width: 15px;
          height: 20px;
        }
      }
    }

    &-table {
      .table {
        margin: auto;
        width: 100%;
        border-collapse: collapse;
        background: #fff;

        .head {
          width: 100%;
          border-bottom: 1px solid #efefef;

          th {
            text-align: center;
            border: 1px solid #999;
            padding: 5px 0;
            font-size: 12px;
            color: #333;
          }
        }

        .row {
          td {
            color: #666;
            font-size: 10px;
            text-align: center;
            padding: 3px 0;
            border: 1px solid #999;
            vertical-align: middle;
          }
        }
      }
    }
  }

  .user-output {
    padding: 0 15px;
    margin-top: 20px;

    &-title {
      margin-bottom: 10px;

      .title {
        font-size: 14px;
        font-weight: bold;
        display: flex;
        align-items: center;

        &::before {
          display: block;
          content: "";
          width: 5px;
          height: 5px;
          background: #000;
          margin-right: 5px;
        }
      }
    }

    &-list {
      background: #fff;
      margin-top: 5px;
      border-radius: 5px;

      &-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding: 10px 5px;
        border-bottom: 1px solid #eee;
      }
    }
  }

  .question-box {
    padding: 0 15px;
    margin-top: 20px;

    &-title {
      margin-bottom: 10px;

      .title {
        font-size: 14px;
        font-weight: bold;
        display: flex;
        align-items: center;

        &::before {
          display: block;
          content: "";
          width: 5px;
          height: 5px;
          background: #000;
          margin-right: 5px;
        }
      }
    }
  }

  .gency-box {
    padding: 0 15px;
    margin-top: 20px;

    &-title {
      margin-bottom: 10px;

      .title {
        font-size: 14px;
        font-weight: bold;
        display: flex;
        align-items: center;

        &::before {
          display: block;
          content: "";
          width: 5px;
          height: 5px;
          background: #000;
          margin-right: 5px;
        }
      }
    }

    &-content {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .gency-img {
        width: 165px;
        height: 50px;
        background: #fff;
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 20px;
        box-sizing: border-box;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }

  .partner-box {
    margin-top: 20px;

    &-title {
      margin-bottom: 10px;
      padding: 0 15px;

      .title {
        font-size: 14px;
        font-weight: bold;
        display: flex;
        align-items: center;

        &::before {
          display: block;
          content: "";
          width: 5px;
          height: 5px;
          background: #000;
          margin-right: 5px;
        }
      }
    }

    &-content {
      padding: 0 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;

      img {
        width: 112px;
        height: 34px;
        margin-bottom: 10px;
        object-fit: contain;
      }
    }
  }

  .contact-btn {
    width: 50px;
    height: 50px;
    background: #0062f8;
    border-radius: 50px;
    position: fixed;
    right: 10px;
    bottom: 150px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 24px;
      height: 24px;
    }
  }

  .pop-activity-box {
    &-title {
      font-size: 18px;
      font-weight: bold;
      padding: 15px;
    }

    &-content {
      padding: 0 15px 15px;
      font-size: 14px;
      line-height: 1.6;

      &-top {
      }

      &-bot {
        margin-top: 20px;
      }
    }

    &-btn {
      margin-top: 60px;
      width: 100%;
      background: #9169fd;
      color: #fff;
      padding: 15px 0;
      font-size: 14px;
      text-align: center;
    }
  }

  .msg-box {
    padding: 15px;

    &-title {
      font-size: 18px;
      font-weight: bold;
      padding: 15px;
      text-align: center;
      border-bottom: 1px solid #eee;
    }

    &-content {
      padding: 0 15px 15px;
      font-size: 14px;
      line-height: 1.6;
      height: 200px;
      overflow: scroll;
    }

    &-btn {
      margin: 0 auto;
      margin-top: 20px;
      width: 95%;
      background: #0062f8;
      color: #fff;
      padding: 15px 0;
      font-size: 14px;
      text-align: center;
      border-radius: 3px;
    }
  }
  .service-box {
    padding: 15px;
    box-sizing: border-box;
    &-btn {
      font-size: 14px;
      padding: 10px 20px;
      border-radius: 30px;
      color: #fff;
      background: #0062f8;
      text-align: center;
      margin-top: 20px;
      &:first-child {
        margin-top: 0;
      }
    }
  }
}

@media (min-width: 640px) {
  /deep/ .van-tab--active {
    color: #0062f8;
    font-weight: 700;
    font-size: 16px;
  }

  /deep/ .van-tabs__line {
    background: #0062f8;
  }

  /deep/ .van-popover__action {
    width: 130px;
    padding: 0 5px;
    height: 40px;
  }

  /deep/ .van-popover__arrow {
    display: none;
  }

  /deep/ .van-popover__action-text {
    height: 40px;
  }

  /deep/ .van-tabs__wrap {
    height: 60px;
  }

  /deep/ .van-tabs__nav--line {
    padding-bottom: 30px;
  }

  /deep/ .van-cell {
    padding: 10px;
  }

  /deep/ .van-tabs__line {
    height: 3px;
  }

  .home-container {
    background: #f9fafb;
    padding-top: 80px;
    position: relative;

    .nav-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px;
      box-sizing: border-box;
      background: #fff;
      position: fixed;
      top: 0;
      width: 540px;
      z-index: 10;

      &-left {
        img {
          width: 30px;
          height: 30px;
        }
      }

      &-right {
        background: #f5f7f9;
        border-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        img {
          width: 25px;
          height: 25px;
        }
      }
    }

    .swipe-bar {
      .my-swipe {
        height: 490px !important;

        img {
          width: 540px;
          height: 490px;
          object-fit: cover;
        }
      }
    }

    .type-bar {
      border-bottom: 1px solid #efefef;

      /deep/ .van-tab--active {
        color: #333;
      }
    }

    .activity-box {
      padding: 15px;

      &-title {
        font-weight: bold;
        font-size: 16px;
      }

      &-content {
        width: 100%;
        box-sizing: border-box;
        background: #fff;
        border-radius: 8px;
        margin-top: 15px;
        padding: 15px;
        box-shadow: 0 1px 5px 3px rgba(0, 0, 0, 0.05);

        &-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
          font-size: 14px;

          .row-right {
            font-weight: bold;
          }
        }

        &-btn {
          width: 100%;
          border-radius: 5px;
          padding: 15px 0;
          color: #fff;
          text-align: center;
          background: #9169fd;
          font-size: 14px;
        }
      }
    }

    .account-box {
      padding: 15px;

      &-title {
        font-weight: bold;
        font-size: 16px;
      }

      &-content {
        width: 100%;
        box-sizing: border-box;
        background: #fff;
        border-radius: 8px;
        margin-top: 15px;
        padding: 15px;
        box-shadow: 0 1px 5px 3px rgba(0, 0, 0, 0.05);

        &-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
          font-size: 14px;

          &:last-child {
            margin-bottom: 0;
          }

          .row-right {
            font-weight: bold;
          }
        }
      }
    }

    .hosting-box {
      background: #fff;
      width: 93%;
      box-sizing: border-box;
      margin: 0 auto;
      margin-top: 15px;
      border-radius: 8px;
      box-shadow: 0 1px 5px 3px rgba(0, 0, 0, 0.05);
      padding: 15px;

      &-title {
        display: flex;
        align-items: center;

        .logo-box {
          width: 30rpx;
          height: 30rpx;
          border-radius: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #efefef;
          margin-right: 10px;

          img {
            width: 20px;
            height: 20px;
          }
        }

        .title {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: bold;

          span {
            background: #fdf8e5;
            padding: 3px;
            color: #4288f4;
            font-weight: 500;
            font-size: 12px;
            margin-left: 5px;
          }
        }
      }

      &-content {
        margin-top: 20px;

        &-top {
          .top-title {
            font-size: 12px;
          }

          .top-bot {
            font-size: 14px;
            margin-top: 3px;
          }
        }

        &-bot {
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin-top: 15px;

          .bot-col {
            display: flex;
            flex-direction: column;
            align-items: center;

            &-top {
              font-size: 12px;
            }

            &-mid {
              font-size: 14px;
              margin-top: 3px;
            }

            &-bot {
              margin-top: 5px;
              font-size: 14px;
            }
          }
        }
      }

      &-btn {
        width: 100%;
        font-size: 14px;
        color: #fff;
        background: linear-gradient(90deg, #096cfe, #30c6ff);
        margin-top: 15px;
        text-align: center;
        padding: 12px 0;
        box-sizing: border-box;
        border-radius: 30px;
        font-weight: bold;
      }
    }

    .defi-box {
      padding: 20px;

      &-title {
        display: flex;
        align-items: center;

        .logo-box {
          width: 30rpx;
          height: 30rpx;
          border-radius: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #efefef;
          margin-right: 10px;

          img {
            width: 20px;
            height: 20px;
          }
        }

        .title {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: bold;

          span {
            background: #fdf8e5;
            padding: 3px;
            color: #4288f4;
            font-weight: 500;
            font-size: 12px;
          }
        }
      }

      &-content {
        &-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 15px;

          .col-row {
            flex: 1;

            &-top {
              font-size: 12px;
            }

            &-bot {
              font-size: 14px;
              margin-top: 5px;
            }
          }
        }

        .join-btn {
          width: 90%;
          background: linear-gradient(90deg, #096cfe, #30c6ff);
          font-size: 14px;
          font-weight: bold;
          color: #fff;
          text-align: center;
          padding: 13px 0;
          margin: 0 auto;
          margin-top: 15px;
          border-radius: 50px;
        }
      }
    }

    .income-box {
      padding: 0 15px;
      margin-top: 15px;

      &-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        .title {
          font-size: 14px;
          font-weight: bold;
          display: flex;
          align-items: center;

          &::before {
            display: block;
            content: "";
            width: 5px;
            height: 5px;
            background: #000;
            margin-right: 5px;
          }
        }

        .view-intro {
          display: flex;
          align-items: center;
          font-size: 14px;
          color: #0062f8;

          img {
            width: 15px;
            height: 20px;
          }
        }
      }

      &-table {
        .table {
          margin: auto;
          width: 100%;
          border-collapse: collapse;
          background: #fff;

          .head {
            width: 100%;
            border-bottom: 1px solid #efefef;

            th {
              text-align: center;
              border: 1px solid #999;
              padding: 5px 0;
              font-size: 12px;
              color: #333;
            }
          }

          .row {
            td {
              color: #666;
              font-size: 10px;
              text-align: center;
              padding: 3px 0;
              border: 1px solid #999;
              vertical-align: middle;
            }
          }
        }
      }
    }

    .user-output {
      padding: 0 15px;
      margin-top: 20px;

      &-title {
        margin-bottom: 10px;

        .title {
          font-size: 14px;
          font-weight: bold;
          display: flex;
          align-items: center;

          &::before {
            display: block;
            content: "";
            width: 5px;
            height: 5px;
            background: #000;
            margin-right: 5px;
          }
        }
      }

      &-list {
        background: #fff;
        margin-top: 5px;
        border-radius: 5px;

        &-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 14px;
          padding: 10px 5px;
          border-bottom: 1px solid #eee;
        }
      }
    }

    .question-box {
      padding: 0 15px;
      margin-top: 20px;

      &-title {
        margin-bottom: 10px;

        .title {
          font-size: 14px;
          font-weight: bold;
          display: flex;
          align-items: center;

          &::before {
            display: block;
            content: "";
            width: 5px;
            height: 5px;
            background: #000;
            margin-right: 5px;
          }
        }
      }
    }

    .gency-box {
      padding: 0 15px;
      margin-top: 20px;

      &-title {
        margin-bottom: 10px;

        .title {
          font-size: 14px;
          font-weight: bold;
          display: flex;
          align-items: center;

          &::before {
            display: block;
            content: "";
            width: 5px;
            height: 5px;
            background: #000;
            margin-right: 5px;
          }
        }
      }

      &-content {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .gency-img {
          width: 225px;
          height: 68px;
          background: #fff;
          border-radius: 2px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 20px;
          box-sizing: border-box;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }
    }

    .partner-box {
      margin-top: 20px;

      &-title {
        margin-bottom: 10px;
        padding: 0 15px;

        .title {
          font-size: 14px;
          font-weight: bold;
          display: flex;
          align-items: center;

          &::before {
            display: block;
            content: "";
            width: 5px;
            height: 5px;
            background: #000;
            margin-right: 5px;
          }
        }
      }

      &-content {
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;

        img {
          width: 150px;
          height: 45px;
          margin-bottom: 10px;
          object-fit: contain;
        }
      }
    }

    .contact-btn {
      width: 50px;
      height: 50px;
      background: #0062f8;
      border-radius: 50px;
      position: fixed;
      right: unset;
      margin-left: 480px;
      bottom: 150px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 35px;
        height: 35px;
      }
    }
    .service-box {
      padding: 15px;
      box-sizing: border-box;
      &-btn {
        font-size: 14px;
        padding: 10px 20px;
        border-radius: 30px;
        color: #fff;
        background: #0062f8;
        text-align: center;
        margin-top: 20px;
        &:first-child {
          margin-top: 0;
        }
      }
    }
  }
}
</style>